// @uifabric/merge-styles@6.11.0
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
import { setVersion } from '@uifabric/set-version';
setVersion('@uifabric/merge-styles', '6.11.0');
